<Overlay bind:show={show} centered {modal}>
  <Panel pt="0" pb="md" px="0" bg="surface" maxw="80vw" maxh="80vh" w={width} border="5" shadow="lg" line="normal" rounded="sm">

    <!-- Modal Title and Close button -->
    <Panel flex items="start">
      <Panel mt="md" ml="lg">
        <Heading bold xl>{title}</Heading>
        {#if hint}<Text sm color="muted">{hint}</Text>{/if}
      </Panel>
      <Box mt="nm" mr="nm" line="1">
        <Button on:click={()=> show=false} bg="transparent" border="none" w=2 p="0" line="fit" hover pointer>
         <Icon name="close" color="primary" size="2" />
        </Button>
      </Box>
    </Panel>

    <!-- Modal Content -->
    <Panel mx="lg">
      <slot></slot>
    </Panel>

  </Panel>
</Overlay>

<script>
  import { Overlay, Panel, Box, Icon, Heading, Button, Text } from 'svelte-stylo';

  export let
    show = false,
    title = '',
    hint = null,
    modal = null,
    sm = null,
    md = true,
    lg = null,
    xl = null

  let width = "36"

  $: {
    if (sm) {
      width = "24"
      md = null
    } else if (lg) {
      width = "60vw"
      md = null
    } else if (xl) {
      width = "80vw"
      md = null
    }
  }

</script>